import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import NumberFormat, { FORMAT_NUMBER, FORMAT_PERCENT, FORMAT_CURRENCY } from './NumberFormat';

export default class NumberRangeFormat extends PureComponent {
  static propTypes = {
    min      : PropTypes.number,
    max      : PropTypes.number,
    format   : PropTypes.oneOf([FORMAT_NUMBER, FORMAT_PERCENT, FORMAT_CURRENCY]),
    currency : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    precision: PropTypes.number,
  };

  render() {
    const { min, max, format, currency, precision } = this.props;

    return (
      <span>
        <NumberFormat number={min} precision={precision}/>
        —
        <NumberFormat number={max} format={format} currency={currency} precision={precision} />
      </span>
    )
  }
}
